import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faUsers,
  faBriefcase,
  faFileAlt,
  faSignOutAlt,
  faFile,
  faGears,
  faBuilding,
  faArchive,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";

function CompanyNavbar() {
  const ID = Cookies.get("log_id");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isEmployeedown, setEmployeedown] = useState(false);
  const [isProductsdown, setIsproductsdown] = useState(false);
  const [isHighlightdown, setIsHighlightdown] = useState(false);
  const [isTargetdown, setTargetdown] = useState(false);
  const navigate = useNavigate();
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleEmployee = () => {
    setEmployeedown(!isEmployeedown);
  };

  const toggleProducts = () => {
    setIsproductsdown(!isProductsdown);
  };

  const toggleHighlight = () => {
    setIsHighlightdown(!isHighlightdown);
  };
  const toggleTarget = () => {
    setTargetdown(!isTargetdown);
  };
  const [company_name, setCompanyname] = useState("");
  const [image, setImage] = useState("");
  function FetchCompanyDetails() {
    axios
      .get(`${url.path}/login_details/${ID}/`)
      .then((res) => {
        if (res.data.status) {
          setCompanyname(res.data.name);
          const img = res.data.image;
          var imag = null;
          if (img) {
            imag = `${url.path}/${img}`;
          }
          setImage(imag);
        }
      })
      .catch((err) => {
        console.log("HOME ERROR==", err);
      });
  }
  useEffect(() => {
    FetchCompanyDetails();
  }, []);
  function Logout() {
    Cookies.remove("User");
    Cookies.remove("log_id");
    navigate("/");
  }
  function bothwork() {
    closeMobileMenu();
    Logout();
  }
  return (
    <div className="dashboard-container">
      <div className="topbar">
        <div className="topbar-logo">JOB MARKET</div>
      </div>

      {/* Sidebar */}
      <div className="dashboard-content">
        <div className="sidebar">
          <div className="sidebar-profile">
            {image ? (
              <img src={image} className="user-img" />
            ) : (
              <img src="user8.jpeg" alt="Profile" />
            )}
            <p>{company_name}</p>
            <span>✅ Verified</span>
          </div>
          <nav>
            <ul>
              <li>
                <NavLink to="">
                  <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                </NavLink>
              </li>
              <li className={`dropdown ${isEmployeedown ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleEmployee();
                  }}
                >
                  <FontAwesomeIcon icon={faUsers} className="icon" /> Employees
                  {isEmployeedown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isEmployeedown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/add_employees">Add</NavLink>
                    </li>
                    <li>
                      <NavLink to="/viewEmployeesCompany">View</NavLink>
                    </li>
                    <li>
                      <NavLink to="/resignation_requests_company">
                        Resignations
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/blacklistform">Blacklist</NavLink>
                    </li>
                    <li>
                      <NavLink to="/lend_employees_page">Lend</NavLink>
                    </li>
                    <li>
                      <NavLink to="/lend_employees_cmp_page">
                        Lend Requests
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/request_employees_page_company">
                        Request
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/workassign">Work assign</NavLink>
                    </li>
                    <li>
                      <NavLink to="/rating">Rating</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isProductsdown ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleProducts();
                  }}
                >
                  <FontAwesomeIcon icon={faArchive} className="icon" /> Products
                  {isProductsdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isProductsdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/add_products">Add</NavLink>
                    </li>
                    <li>
                      <NavLink to="/company_own_products">Own</NavLink>
                    </li>
                    <li>
                      <NavLink to="/other_company_products">Others</NavLink>
                    </li>
                    <li>
                      <NavLink to="/product_ads_page_company">
                        Ads Request
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/all_ads_company_page">All Ads</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown();
                  }}
                >
                  <FontAwesomeIcon icon={faBriefcase} className="icon" /> Jobs
                  {isDropdownOpen ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isDropdownOpen && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/add_jobs_page">Add</NavLink>
                    </li>
                    <li>
                      <NavLink to="/view_jobs_company">View</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isHighlightdown ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleHighlight();
                  }}
                >
                  <FontAwesomeIcon icon={faBuilding} className="icon" />{" "}
                  Highlight
                  {isHighlightdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isHighlightdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/company_highlight">Company</NavLink>
                    </li>
                    <li>
                      <NavLink to="/product_highlight">Product</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isTargetdown ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTarget();
                  }}
                >
                  <FontAwesomeIcon icon={faBullseye} className="icon" /> Target
                  Audience
                  {isTargetdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isTargetdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/target_audience_page">Request</NavLink>
                    </li>
                    <li>
                      <NavLink to="/target_audience_requests_cmp">All</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <NavLink to="/premiumMembershipCompany">
                  <FontAwesomeIcon icon={faFileAlt} className="icon" /> Premium
                  Membership
                </NavLink>
              </li>
              <li>
                <NavLink to="">
                  <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job
                  Applicants
                </NavLink>
              </li>
              <li>
                <NavLink to="/ratingfactors">
                  <FontAwesomeIcon icon={faFileAlt} className="icon" />
                  Rating Factors
                </NavLink>
              </li>
              <li>
                <a onClick={Logout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                  Logout
                </a>
              </li>
            </ul>
          </nav>
        </div>

        {/* Mobile Header */}
        <div className="mobile-header">
          <FaBars className="menu-icon" onClick={toggleMobileMenu} />
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobileMenuOpen && (
          <div className="sidebar mobile-sidebar">
            <button className="close-menu-btn" onClick={closeMobileMenu}>
              <FaTimes className="close-icon" />
            </button>
            <nav>
              <ul>
                <li>
                  <NavLink to="" onClick={closeMobileMenu}>
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                  </NavLink>
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleEmployee}>
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Employees
                    {isEmployeedown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isEmployeedown && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink to="/add_employees" onClick={closeMobileMenu}>
                          Add
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/viewEmployeesCompany"
                          onClick={closeMobileMenu}
                        >
                          View
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/resignation_requests_company"
                          onClick={closeMobileMenu}
                        >
                          Resignations
                        </NavLink>
                      </li>

                      <li>
                        <NavLink to="/blacklistform" onClick={closeMobileMenu}>
                          Blacklist
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/lend_employees_page"
                          onClick={closeMobileMenu}
                        >
                          Lend
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/lend_employees_cmp_page"
                          onClick={closeMobileMenu}
                        >
                          Lend Requests
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/request_employees_page_company"
                          onClick={closeMobileMenu}
                        >
                          Request
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleProducts}>
                    <FontAwesomeIcon icon={faGears} className="icon" /> Products
                    {isProductsdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isProductsdown && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink to="/add_products" onClick={closeMobileMenu}>
                          Add
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/company_own_products"
                          onClick={closeMobileMenu}
                        >
                          Own
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/other_company_products"
                          onClick={closeMobileMenu}
                        >
                          Others
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/product_ads_page_company"
                          onClick={closeMobileMenu}
                        >
                          Ads Request
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/all_ads_company_page"
                          onClick={closeMobileMenu}
                        >
                          All Ads
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleDropdown}>
                    <FontAwesomeIcon icon={faBriefcase} className="icon" /> Jobs
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isDropdownOpen && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink to="/add_jobs_page" onClick={closeMobileMenu}>
                          Add
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/view_jobs_company"
                          onClick={closeMobileMenu}
                        >
                          View
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <button
                    className="dropdown-toggles"
                    onClick={toggleHighlight}
                  >
                    <FontAwesomeIcon icon={faBuilding} className="icon" />{" "}
                    Highlight
                    {isHighlightdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isHighlightdown && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink
                          to="/company_highlight"
                          onClick={closeMobileMenu}
                        >
                          Company
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/product_highlight"
                          onClick={closeMobileMenu}
                        >
                          Product
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleTarget}>
                    <FontAwesomeIcon icon={faBullseye} className="icon" />{" "}
                    Target Audience
                    {isTargetdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isTargetdown && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink
                          to="/target_audience_page"
                          onClick={closeMobileMenu}
                        >
                          Request
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/target_audience_requests_cmp"
                          onClick={closeMobileMenu}
                        >
                          All
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <NavLink
                    to="/premiumMembershipCompany"
                    onClick={closeMobileMenu}
                  >
                    <FontAwesomeIcon icon={faFileAlt} className="icon" />{" "}
                    Premium Membership
                  </NavLink>
                </li>
                <li>
                  <NavLink to="" onClick={closeMobileMenu}>
                    <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job
                    Applicants
                  </NavLink>
                </li>

                <li>
                  <NavLink to="" onClick={bothwork}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                    Logout
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
}
export default CompanyNavbar;
